import { ShieldAlert } from "lucide-react";
import { env } from "../env.js";
import { Button, CenteredSpinner } from "../components/ui.js";

export function LoadingScreen({ label }: { label?: string }) {
  return (
    <div className="flex h-screen items-center justify-center">
      <CenteredSpinner label={label ?? "Loading…"} />
    </div>
  );
}

export function ForbiddenScreen() {
  function backToLogin() {
    const next = encodeURIComponent(window.location.href);
    window.location.assign(`${env.apiBase}/auth/login?next=${next}`);
  }
  return (
    <div className="flex h-screen items-center justify-center px-6">
      <div className="surface w-full max-w-sm p-8 text-center">
        <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-destructive/10 ring-1 ring-destructive/25">
          <ShieldAlert className="h-7 w-7 text-destructive" />
        </span>
        <h1 className="font-display text-lg font-semibold text-foreground">
          Access denied
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You are signed in, but this account is not an administrator. Ask an
          existing admin to grant you the ADMIN role.
        </p>
        <Button variant="secondary" onClick={backToLogin} className="mt-6 w-full">
          Switch account
        </Button>
      </div>
    </div>
  );
}
